export enum PLACEMENT {
  Auto = 'auto',
  AutoEnd = 'auto-end',
  AutoStart = 'auto-start',
  Bottom = 'bottom',
  BottomEnd = 'bottom-end',
  BottomStart = 'bottom-start',
  Left = 'left',
  LeftEnd = 'left-end',
  LeftStart = 'left-start',
  Right = 'right',
  RightEnd = 'right-end',
  RightStart = 'right-start',
  Top = 'top',
  TopEnd = 'top-end',
  TopStart = 'top-start',
}
